const firebaseConfig = {
  apiKey: "AIzaSyCKAtMzprk1NfDsbtc3xlUDNhNb6btkyEo",
  authDomain: "fucas-49839.firebaseapp.com",
  projectId: "fucas-49839",
  storageBucket: "fucas-49839.appspot.com",
  messagingSenderId: "784602086929",
  appId: "1:784602086929:web:4afe8d6c8910050d4f7bb0",
};

export default firebaseConfig;
